module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-tabs', {
    attrs: {
      "flat": "",
      "color": "primary",
      "dark": "",
      "grow": "",
      "height": "40",
      "fixed-tabs": ""
    },
    model: {
      value: (_vm.tab),
      callback: function($$v) {
        _vm.tab = $$v
      },
      expression: "tab"
    }
  }, _vm._l((_vm.tabitems), function(tabitem, n) {
    return _c('v-tab', {
      key: n,
      attrs: {
        "href": ("#tab-" + n)
      },
      on: {
        "change": function($event) {
          return _vm.refreshTab()
        }
      }
    }, [_vm._v("\n      " + _vm._s(tabitem) + "\n    ")])
  }), 1), _vm._v(" "), _c('v-container', {
    staticClass: "pa-0 ma-0",
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-tabs-items', {
    model: {
      value: (_vm.tab),
      callback: function($$v) {
        _vm.tab = $$v
      },
      expression: "tab"
    }
  }, [_c('v-tab-item', {
    key: 0,
    attrs: {
      "value": "tab-0"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.lAction === 'view') ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', [(_vm.$vuetify.breakpoint.smAndUp && _vm.ppmCal.length) ? _c('v-flex', {
    staticClass: "text-xs-left pb-0 pl-2",
    attrs: {
      "xs7": ""
    }
  }, _vm._l((_vm.statusChip), function(chip, index) {
    return _c('span', {
      key: index
    }, [_c('v-chip', {
      class: 'caption white--text mx-0 ' + (chip === 'Unscheduled' ? 'grey' : chip === 'Scheduled' ? 'blue' : chip === 'Completed' ? 'green' : 'red'),
      attrs: {
        "small": "",
        "disabled": ""
      }
    }, [_vm._v("\n                          " + _vm._s(chip) + "\n                        ")])], 1)
  }), 0) : (!_vm.ppmCal.length) ? _c('v-flex', {
    attrs: {
      "xs7": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-right pb-0 pr-2",
    attrs: {
      "xs12": "",
      "sm5": ""
    }
  }, _vm._l((_vm.chips), function(chip, index) {
    return _c('span', {
      key: index
    }, [_c('v-chip', {
      class: _vm.enableChip === chip ? 'primary white--text px-1' : 'px-1',
      attrs: {
        "small": ""
      },
      on: {
        "click": function($event) {
          return _vm.returnEnableChip(chip)
        }
      }
    }, [_c('span', {
      staticStyle: {
        "cursor": "pointer"
      }
    }, [_vm._v(_vm._s(chip))])])], 1)
  }), 0), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "margin-top": "-15px",
      "margin-left": "20px"
    },
    attrs: {
      "xs5": ""
    }
  }, [_c('v-switch', {
    staticClass: "my-label-text-size",
    attrs: {
      "label": "Show Nonequipment"
    },
    on: {
      "change": function($event) {
        return _vm.loadPpmList()
      }
    },
    model: {
      value: (_vm.showNonEq),
      callback: function($$v) {
        _vm.showNonEq = $$v
      },
      expression: "showNonEq"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-right",
    attrs: {
      "xs5": ""
    }
  }, [_c('v-btn', {
    staticClass: "accent",
    attrs: {
      "small": ""
    },
    on: {
      "click": _vm.downloadAsPdf
    }
  }, [_vm._v("Download As Pdf")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "margin-top": "-30px",
      "margin-left": "10px"
    },
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Filter By Category",
      "items": _vm.catList,
      "item-value": "asset_cat_id",
      "item-text": "asset_cat",
      "clearable": "",
      "chips": "",
      "multiple": "",
      "hide-details": "",
      "dense": "",
      "deletable-chips": "",
      "return-object": ""
    },
    on: {
      "input": function($event) {
        return _vm.loadPpmList(_vm.filterList.asset_cat_list)
      }
    },
    model: {
      value: (_vm.filterList.asset_cat_list),
      callback: function($$v) {
        _vm.$set(_vm.filterList, "asset_cat_list", $$v)
      },
      expression: "filterList.asset_cat_list"
    }
  })], 1)], 1), _vm._v(" "), (_vm.enableChip === 'Month') ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "id": "pdf_report"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-left pt-0",
    attrs: {
      "xs2": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "fab": "",
      "outline": "",
      "small": "",
      "color": "info"
    },
    on: {
      "click": function($event) {
        return _vm.prevMonth()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("keyboard_arrow_left")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-center pt-3",
    attrs: {
      "xs8": ""
    }
  }, [_c('span', {
    class: _vm.$vuetify.breakpoint.smAndUp ? 'info--text title' : 'info--text .subheading'
  }, [_vm._v(_vm._s(_vm.calViewTitle + ' [Week ' + _vm.startingWeekOfMonth + ' - Week ' + _vm.endingWeekOfMonth + ']'))])]), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-right pt-0",
    attrs: {
      "xs2": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "fab": "",
      "outline": "",
      "small": "",
      "color": "info"
    },
    on: {
      "click": function($event) {
        return _vm.nextMonth()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("keyboard_arrow_right")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-divider'), _vm._v(" "), _c('v-sheet', {
    attrs: {
      "height": "500"
    }
  }, [_c('v-calendar', {
    ref: "calendar",
    attrs: {
      "now": _vm.today,
      "value": _vm.today,
      "weekdays": [1, 2, 3, 4, 5, 6, 0],
      "color": "primary"
    },
    scopedSlots: _vm._u([{
      key: "day",
      fn: function(ref) {
        var date = ref.date;

        return [_vm._l((_vm.eventsMap[date]), function(event) {
          return [_c('v-menu', {
            attrs: {
              "offset-x": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;

                return [_c('div', _vm._g({
                  directives: [{
                    name: "ripple",
                    rawName: "v-ripple"
                  }],
                  class: (_vm.handy.formatDBDate(event.sched_dt) >= _vm.today) && (event.ppm_status === 'Scheduled') ? 'blue white--text text-xs-center caption' : (_vm.handy.formatDBDate(event.comp_dt) && (event.ppm_status === 'Completed') ? 'green white--text text-xs-center caption' : _vm.handy.formatDBDate(event.ppm_week_start_dt) && (event.ppm_status === 'Unscheduled') ? 'grey white--text text-xs-center caption' : 'red white--text text-xs-center caption'),
                  staticStyle: {
                    "cursor": "pointer",
                    "margin-top": "1px",
                    "border-radius": "4px"
                  },
                  domProps: {
                    "innerHTML": _vm._s(event.freq + (event.asset_cat ? ' (' + _vm.handy.unique(event.asset_category) + ')' : event.noneq_nm.length > 0 ? ' (' + event.noneq_nm.join() + ')' : '') + ' - <strong>' + (event.freq === 'S' ? event.tot_onlyonce : (event.freq === 'W' ? event.tot_weekly : (event.freq === 'BW' ? event.tot_biweekly : (event.freq === 'M' ? event.tot_monthly : (event.freq === 'BM' ? event.tot_bimonthly : (event.freq === 'Q' ? event.tot_quaterly : (event.freq === 'HY' ? event.tot_half_yealy : event.tot_yearly))))))) + '</strong>')
                  }
                }, on))]
              }
            }], null, true)
          }, [_vm._v(" "), _c('v-card', {
            attrs: {
              "width": "400px"
            }
          }, [_c('v-card-title', {
            staticClass: "py-0 pl-2 primary white--text"
          }, [_c('v-flex', {
            staticClass: "pa-0",
            attrs: {
              "xs12": ""
            }
          }, [_c('div', {
            staticClass: "py-2 pr-2 lighten-1 white--text font-weight-bold"
          }, [_vm._v("\n                                      " + _vm._s('Week ' + event.ppm_week + ': ' + ((_vm.handy.formatDBDate(event.sched_dt) < _vm.today) && (event.ppm_status === 'Scheduled') ? 'Past Due' : event.ppm_status) + ' PPM Activities') + "\n                                    ")])])], 1), _vm._v(" "), _c('v-card-text', {
            staticClass: "py-0 pl-2 pr-0 black--text"
          }, _vm._l((event.ppmList), function(ppm, n) {
            return _c('v-flex', {
              key: n,
              attrs: {
                "xs12": ""
              }
            }, [_c('v-layout', {
              attrs: {
                "row": "",
                "wrap": ""
              }
            }, [_c('v-flex', {
              staticClass: "py-2",
              attrs: {
                "xs8": ""
              }
            }, [_c('div', {
              staticClass: "font-weight-bold"
            }, [_vm._v(_vm._s(ppm.freq + ' - ' + (ppm.asset_id ? (ppm.asset_cat + ' ' + ppm.asset_name) : ppm.noneq_name)))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(ppm.asset_tag ? ppm.asset_tag : '-'))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(ppm.activity_desc))])]), _vm._v(" "), _c('v-flex', {
              staticClass: "pa-0 text-xs-right",
              attrs: {
                "xs4": ""
              }
            }, [_c('v-btn', {
              staticClass: "pa-0 ma-0",
              attrs: {
                "icon": ""
              },
              on: {
                "click": function($event) {
                  return _vm.prepareEdit(ppm, event)
                }
              }
            }, [_c('v-icon', {
              attrs: {
                "small": ""
              }
            }, [_vm._v("edit")])], 1), _vm._v(" "), _c('v-btn', {
              staticClass: "pa-0 ma-0",
              attrs: {
                "icon": ""
              },
              on: {
                "click": function($event) {
                  return _vm.loadServiceHistory(ppm, event.ppm_week)
                }
              }
            }, [_c('v-icon', {
              attrs: {
                "small": ""
              }
            }, [_vm._v("build")])], 1)], 1)], 1), _vm._v(" "), (n !== event.ppmList.length - 1) ? _c('v-divider') : _vm._e()], 1)
          }), 1)], 1)], 1)]
        })]
      }
    }], null, false, 3500760085),
    model: {
      value: (_vm.start),
      callback: function($$v) {
        _vm.start = $$v
      },
      expression: "start"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.enableChip === 'Year') ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-left pt-0",
    attrs: {
      "xs2": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "fab": "",
      "outline": "",
      "small": "",
      "color": "info"
    },
    on: {
      "click": function($event) {
        return _vm.prevYear()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("keyboard_arrow_left")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-center pt-3",
    attrs: {
      "xs8": ""
    }
  }, [_c('span', {
    class: _vm.$vuetify.breakpoint.smAndUp ? 'info--text title' : 'info--text .subheading'
  }, [_vm._v("\n                        " + _vm._s('52 Weeks PPM Schedule (' + _vm.calYearViewTitle + ')' + (_vm.enabledFilter ? (_vm.filteredList ? ' - ' + _vm.filteredList : '') : '')) + "\n                      ")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-right pt-0",
    attrs: {
      "xs2": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "fab": "",
      "outline": "",
      "small": "",
      "color": "info"
    },
    on: {
      "click": function($event) {
        return _vm.nextYear()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("keyboard_arrow_right")])], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "mx-2 mb-2 mt-0",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.endingWeek), function(week, i) {
    return _c('v-flex', {
      key: i,
      style: (i < (_vm.currentWeek - 1) ? 'background-color: #F8F8F8; border: 1px solid #F0F0F0; cursor: pointer; min-height: 74.2px;' : 'border: 1px solid #F0F0F0; cursor: pointer; min-height: 74.2px;'),
      attrs: {
        "xs2": "",
        "sm1": ""
      }
    }, [_c('v-menu', {
      attrs: {
        "close-on-content-click": false,
        "offset-x": ""
      }
    }, [_c('div', {
      staticClass: "mt-1",
      attrs: {
        "slot": "activator"
      },
      slot: "activator"
    }, [_c('span', {
      style: (i === (_vm.currentWeek - 1) ? 'border: 1px solid orange; border-radius: 50%; padding: 7px;' : '')
    }, [_vm._v(_vm._s(i + 1))]), _vm._v(" "), _vm._l((_vm.ppmCal.filter(function (rec) { return rec.ppm_week === (i + 1) && (rec.year === _vm.calYearViewTitle); })), function(year, n) {
      return _c('div', {
        key: n,
        class: n === 0 ? 'mt-2 text-xs-center' : 'text-xs-center'
      }, [_c('div', {
        class: ((year.sched_dt ? _vm.handy.formatDBDate(year.sched_dt.split(',')[0]) : _vm.handy.formatDBDate(year.sched_dt)) >= _vm.today) && (year.ppm_status === 'Scheduled') ? 'blue white--text caption' : (_vm.handy.formatDBDate(year.comp_dt) && (year.ppm_status === 'Completed') ? 'green white--text caption' : _vm.handy.formatDBDate(year.ppm_week_start_dt) && (year.ppm_status === 'Unscheduled') ? 'grey white--text caption' : 'red white--text caption'),
        style: (_vm.$vuetify.breakpoint.smAndUp ? 'margin: 2px 1px 2px 1px; border-radius: 4px; padding: 2px; width: 75px;' : 'margin: 2px 1px 2px 1px; border-radius: 4px; padding: 2px; width: 49px;'),
        on: {
          "click": function($event) {
            _vm.currentFreq = year.freq, _vm.currentStatus = year.ppm_status
          }
        }
      }, [_vm._v("\n                            " + _vm._s((year.freq === 'S' ? year.tot_onlyonce : (year.freq === 'W' ? year.tot_weekly : (year.freq === 'BW' ? year.tot_biweekly : (year.freq === 'M' ? year.tot_monthly : (year.freq === 'BM' ? year.tot_bimonthly : (year.freq === 'Q' ? year.tot_quaterly : (year.freq === 'HY' ? year.tot_half_yealy : year.tot_yearly))))))) + ' ' + year.freq + (year.asset_cat ? ' (' + _vm.handy.unique(year.asset_category) + ')' : year.noneq_nm.length > 0 ? ' (' + year.noneq_nm.join() + ')' : '')) + "\n                            ")])])
    })], 2), _vm._v(" "), _c('v-card', {
      attrs: {
        "width": "400px"
      }
    }, [_c('v-card-text', {
      staticClass: "pa-0 black--text"
    }, _vm._l((_vm.ppmCal.filter(function (rec) { return (rec.ppm_status === _vm.currentStatus) && (rec.freq === _vm.currentFreq) && (rec.ppm_week === (i + 1)) && (rec.year === _vm.calYearViewTitle); })), function(year, n) {
      return _c('div', {
        key: n
      }, [(n < 1) ? _c('v-flex', {
        staticClass: "pa-0 primary white--text",
        attrs: {
          "xs12": ""
        }
      }, [_c('div', {
        staticClass: "py-2 px-2 lighten-1 white--text font-weight-bold"
      }, [_vm._v("\n                                  " + _vm._s('Week ' + year.ppm_week + ': ' + ((_vm.handy.formatDBDate(year.sched_dt) < _vm.today) && (year.ppm_status === 'Scheduled') ? 'Past Due' : year.ppm_status) + ' PPM Activities') + "\n                                ")])]) : _vm._e(), _vm._v(" "), _vm._l((year.ppmList), function(ppm, n) {
        return _c('v-flex', {
          key: n,
          attrs: {
            "xs12": ""
          }
        }, [_c('v-layout', {
          attrs: {
            "row": "",
            "wrap": ""
          }
        }, [_c('v-flex', {
          staticClass: "py-2 pl-2 pr-0",
          attrs: {
            "xs8": ""
          }
        }, [_c('div', {
          staticClass: "font-weight-bold"
        }, [_vm._v(_vm._s(ppm.freq + ' - ' + (ppm.asset_id ? (ppm.asset_cat + ' ' + ppm.asset_name) : ppm.noneq_name)))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(ppm.activity_desc))])]), _vm._v(" "), _c('v-flex', {
          staticClass: "pa-0 text-xs-right",
          attrs: {
            "xs4": ""
          }
        }, [_c('v-btn', {
          staticClass: "pa-0 ma-0",
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              return _vm.prepareEdit(ppm, year.ppm_week)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "small": ""
          }
        }, [_vm._v("edit")])], 1), _vm._v(" "), _c('v-btn', {
          staticClass: "pa-0 ma-0",
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              return _vm.loadServiceHistory(ppm, year.ppm_week)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "small": ""
          }
        }, [_vm._v("build")])], 1)], 1)], 1), _vm._v(" "), (n !== year.ppmList.length - 1) ? _c('v-divider') : _vm._e()], 1)
      })], 2)
    }), 0)], 1)], 1)], 1)
  }), 1)], 1) : _vm._e()], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-tab-item', {
    key: 1,
    attrs: {
      "value": "tab-1"
    }
  }, [(_vm.lRAction === 'view') ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "pa-2",
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-card', {
    on: {
      "click": function($event) {
        return _vm.viewPpmSummary()
      }
    }
  }, [_c('v-card-text', {
    staticClass: "text-xs-center"
  }, [_vm._v("\n                    PPM Summary\n                  ")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-2",
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-card', {
    on: {
      "click": function($event) {
        return _vm.viewServiceHistRep()
      }
    }
  }, [_c('v-card-text', {
    staticClass: "text-xs-center"
  }, [_vm._v("\n                    Service History Reports\n                  ")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.lRAction === 'viewServiceHist') ? _c('v-container', {
    staticClass: "pt-0"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "py-0 title"
  }, [_c('v-btn', {
    staticStyle: {
      "margin-left": "-60px"
    },
    attrs: {
      "small": "",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.lRAction = 'view'
      }
    }
  }, [_c('v-icon', [_vm._v("keyboard_backspace")])], 1), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "margin-left": "-40px"
    },
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, _vm._l((_vm.reportChip), function(chip, index) {
    return _c('span', {
      key: index
    }, [_c('v-chip', {
      class: _vm.selectedChip === chip ? 'primary white--text' : '',
      style: (_vm.$vuetify.breakpoint.smAndUp ? '' : 'width:30%;'),
      attrs: {
        "small": ""
      },
      on: {
        "click": function($event) {
          return _vm.loadDashboardBasedOnPeriod(chip)
        }
      }
    }, [_vm._v("\n                            " + _vm._s(chip) + "\n                          ")])], 1)
  }), 0), _vm._v(" "), (_vm.selectedChip === 'Specific Date') ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "sm4": ""
    }
  }, [_c('v-dialog', {
    ref: "dlgFromDt",
    attrs: {
      "persistent": "",
      "lazy": "",
      "max-width": "290px",
      "return-value": _vm.lReport.from_dt
    },
    on: {
      "update:returnValue": function($event) {
        return _vm.$set(_vm.lReport, "from_dt", $event)
      },
      "update:return-value": function($event) {
        return _vm.$set(_vm.lReport, "from_dt", $event)
      }
    },
    model: {
      value: (_vm.dlgFromDt),
      callback: function($$v) {
        _vm.dlgFromDt = $$v
      },
      expression: "dlgFromDt"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "From",
      "append-icon": "event",
      "readonly": "",
      "clearable": "",
      "hide-details": ""
    },
    slot: "activator",
    model: {
      value: (_vm.lReport.from_dt),
      callback: function($$v) {
        _vm.$set(_vm.lReport, "from_dt", $$v)
      },
      expression: "lReport.from_dt"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "first-day-of-week": "1"
    },
    model: {
      value: (_vm.lReport.from_dt),
      callback: function($$v) {
        _vm.$set(_vm.lReport, "from_dt", $$v)
      },
      expression: "lReport.from_dt"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.dlgFromDt = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "accent"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.dlgFromDt.save(_vm.lReport.from_dt)
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": "",
      "sm4": ""
    }
  }, [_c('v-dialog', {
    ref: "dlgToDt",
    attrs: {
      "persistent": "",
      "lazy": "",
      "max-width": "290px",
      "return-value": _vm.lReport.to_dt
    },
    on: {
      "update:returnValue": function($event) {
        return _vm.$set(_vm.lReport, "to_dt", $event)
      },
      "update:return-value": function($event) {
        return _vm.$set(_vm.lReport, "to_dt", $event)
      }
    },
    model: {
      value: (_vm.dlgToDt),
      callback: function($$v) {
        _vm.dlgToDt = $$v
      },
      expression: "dlgToDt"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "To",
      "append-icon": "event",
      "readonly": "",
      "clearable": "",
      "hide-details": ""
    },
    slot: "activator",
    model: {
      value: (_vm.lReport.to_dt),
      callback: function($$v) {
        _vm.$set(_vm.lReport, "to_dt", $$v)
      },
      expression: "lReport.to_dt"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "first-day-of-week": "1"
    },
    model: {
      value: (_vm.lReport.to_dt),
      callback: function($$v) {
        _vm.$set(_vm.lReport, "to_dt", $$v)
      },
      expression: "lReport.to_dt"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.dlgToDt = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "accent"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.dlgToDt.save(_vm.lReport.to_dt)
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": "",
      "sm2": ""
    }
  }, [_c('v-btn', {
    staticClass: "accent",
    attrs: {
      "fab": "",
      "small": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.loadDashboardBasedOnPeriod('Specific Date')
      }
    }
  }, [_vm._v("\n                            Go\n                            ")])], 1)], 1)], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "py-0 title grey lighten-4"
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_vm._v("\n                        " + _vm._s('Service History Lists (' + _vm.serviceHist.length + ')') + "\n                      ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-download-as', {
    attrs: {
      "headers": _vm.serviceHistHead,
      "items": _vm.serviceHist,
      "title": "Service History List",
      "landscape": true
    }
  })], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0"
  }, [_c('v-data-table', {
    attrs: {
      "headers": _vm.serviceHistHead,
      "items": _vm.serviceHist,
      "search": _vm.search,
      "hide-actions": "",
      "disable-initial-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.handy.formatDate(props.item.service_hist_dt)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.asset_cat))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.asset_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.asset_tag))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.service_hist_desc))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.service_hist_cost))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.asset_location))])])]
      }
    }], null, false, 2815213268)
  })], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.lRAction === 'viewPpmSum') ? _c('v-container', {
    staticClass: "pt-0"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "py-0 title"
  }, [_c('v-btn', {
    staticStyle: {
      "margin-left": "-60px"
    },
    attrs: {
      "small": "",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.lRAction = 'view'
      }
    }
  }, [_c('v-icon', [_vm._v("keyboard_backspace")])], 1), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "margin-left": "-40px"
    },
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, _vm._l((_vm.reportChip), function(chip, index) {
    return _c('span', {
      key: index
    }, [_c('v-chip', {
      class: _vm.selectedChipForPpm === chip ? 'primary white--text' : '',
      style: (_vm.$vuetify.breakpoint.smAndUp ? '' : 'width:30%;'),
      attrs: {
        "small": ""
      },
      on: {
        "click": function($event) {
          return _vm.loadPpmListBasedOnPeriod(chip)
        }
      }
    }, [_vm._v("\n                            " + _vm._s(chip) + "\n                          ")])], 1)
  }), 0), _vm._v(" "), (_vm.selectedChipForPpm === 'Specific Date') ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "sm4": ""
    }
  }, [_c('v-dialog', {
    ref: "dlgStartDt",
    attrs: {
      "persistent": "",
      "lazy": "",
      "max-width": "290px",
      "return-value": _vm.lPpmRep.from_dt
    },
    on: {
      "update:returnValue": function($event) {
        return _vm.$set(_vm.lPpmRep, "from_dt", $event)
      },
      "update:return-value": function($event) {
        return _vm.$set(_vm.lPpmRep, "from_dt", $event)
      }
    },
    model: {
      value: (_vm.dlgStartDt),
      callback: function($$v) {
        _vm.dlgStartDt = $$v
      },
      expression: "dlgStartDt"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "From",
      "append-icon": "event",
      "readonly": "",
      "clearable": "",
      "hide-details": ""
    },
    slot: "activator",
    model: {
      value: (_vm.lPpmRep.from_dt),
      callback: function($$v) {
        _vm.$set(_vm.lPpmRep, "from_dt", $$v)
      },
      expression: "lPpmRep.from_dt"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "first-day-of-week": "1"
    },
    model: {
      value: (_vm.lPpmRep.from_dt),
      callback: function($$v) {
        _vm.$set(_vm.lPpmRep, "from_dt", $$v)
      },
      expression: "lPpmRep.from_dt"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.dlgStartDt = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "accent"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.dlgStartDt.save(_vm.lPpmRep.from_dt)
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": "",
      "sm4": ""
    }
  }, [_c('v-dialog', {
    ref: "dlgEndDt",
    attrs: {
      "persistent": "",
      "lazy": "",
      "max-width": "290px",
      "return-value": _vm.lPpmRep.to_dt
    },
    on: {
      "update:returnValue": function($event) {
        return _vm.$set(_vm.lPpmRep, "to_dt", $event)
      },
      "update:return-value": function($event) {
        return _vm.$set(_vm.lPpmRep, "to_dt", $event)
      }
    },
    model: {
      value: (_vm.dlgEndDt),
      callback: function($$v) {
        _vm.dlgEndDt = $$v
      },
      expression: "dlgEndDt"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "To",
      "append-icon": "event",
      "readonly": "",
      "clearable": "",
      "hide-details": ""
    },
    slot: "activator",
    model: {
      value: (_vm.lPpmRep.to_dt),
      callback: function($$v) {
        _vm.$set(_vm.lPpmRep, "to_dt", $$v)
      },
      expression: "lPpmRep.to_dt"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "first-day-of-week": "1"
    },
    model: {
      value: (_vm.lPpmRep.to_dt),
      callback: function($$v) {
        _vm.$set(_vm.lPpmRep, "to_dt", $$v)
      },
      expression: "lPpmRep.to_dt"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.dlgEndDt = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "accent"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.dlgEndDt.save(_vm.lPpmRep.to_dt)
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": "",
      "sm2": ""
    }
  }, [_c('v-btn', {
    staticClass: "accent",
    attrs: {
      "fab": "",
      "small": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.loadPpmListBasedOnPeriod('Specific Date')
      }
    }
  }, [_vm._v("\n                            Go\n                            ")])], 1)], 1)], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "py-0 title grey lighten-4"
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_vm._v("\n                        " + _vm._s('PPM Summary (' + _vm.ppmList.length + ')') + "\n                      ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-download-as', {
    attrs: {
      "headers": _vm.ppmListHead,
      "items": _vm.ppmList,
      "title": "PPM Summary",
      "landscape": true
    }
  })], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0"
  }, [_c('v-data-table', {
    attrs: {
      "headers": _vm.ppmListHead,
      "items": _vm.ppmList,
      "search": _vm.search,
      "hide-actions": "",
      "disable-initial-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', [_c('td', [_vm._v(_vm._s(props.item.ppm_cat))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.asset_cat ? props.item.asset_cat : '-'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.asset_name ? props.item.asset_name : props.item.noneq_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.activity_desc))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.asset_tag ? props.item.asset_tag : '-'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.freq))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.activity_by))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.sched_dt ? _vm.handy.formatDate(props.item.sched_dt) : '-'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.comp_dt ? _vm.handy.formatDate(props.item.comp_dt) : '-'))]), _vm._v(" "), _c('td', [_c('v-btn', {
          staticClass: "primary--text",
          attrs: {
            "icon": "",
            "small": ""
          },
          on: {
            "click": function($event) {
              return _vm.loadHistoryBasedOnAssetId(props.item)
            }
          }
        }, [_c('v-icon', [_vm._v("history")])], 1)], 1)])]
      }
    }], null, false, 3353747591)
  })], 1)], 1)], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), (_vm.lAction === 'view' && this.tab === 'tab-0') ? _c('v-btn', {
    style: ('position:fixed; ' + (_vm.$vuetify.breakpoint.smAndDown ? 'bottom:15px; left:10px;' : 'bottom:15px; left:310px;')),
    attrs: {
      "dark": "",
      "fab": "",
      "fixed": "",
      "small": "",
      "color": "accent"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.prepareUploadPpmPlanner()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("upload")])], 1) : _vm._e(), _vm._v(" "), (_vm.lAction === 'view' && _vm.lRAction === 'viewServiceHist') ? _c('v-btn', {
    style: ('position:fixed; ' + (_vm.$vuetify.breakpoint.smAndDown ? 'bottom:15px; left:60px;' : 'bottom:15px; left:360px;')),
    attrs: {
      "small": "",
      "dark": "",
      "fab": "",
      "fixed": "",
      "color": "accent"
    },
    nativeOn: {
      "click": function($event) {
        this.tab === 'tab-0' ? _vm.prepareFilter() : _vm.prepareSerHistFilter()
      }
    }
  }, [_c('v-badge', {
    attrs: {
      "overlap": "",
      "color": "info"
    },
    scopedSlots: _vm._u([(this.tab === 'tab-0' ? _vm.enabledFilter : _vm.enabledHistFilter) ? {
      key: "badge",
      fn: function() {
        return [_c('v-icon', {
          staticClass: "caption"
        }, [_vm._v("done")])]
      },
      proxy: true
    } : null], null, true)
  }, [_vm._v(" "), _c('v-icon', {
    staticClass: "pa-2"
  }, [_vm._v("filter_list")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.lAction === 'view' && this.tab === 'tab-0') ? _c('v-btn', {
    style: ('position:fixed; ' + (_vm.$vuetify.breakpoint.smAndDown ? 'bottom:15px; right:15px;' : 'bottom:15px; right:15px;')),
    attrs: {
      "dark": "",
      "fab": "",
      "fixed": "",
      "color": "accent"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.prepareCreate()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("add")])], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), (_vm.lAction === 'create') ? _c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-form', {
    ref: "lForm",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.saveChanges(_vm.lAction, _vm.lPpm.ppm_week)
      }
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm7": "",
      "mx-auto": ""
    }
  }, [_c('v-card-text', {
    staticClass: "px-2 pb-2 pt-0"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "pl-0",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-radio-group', {
    staticClass: "pa-0 my-label-text-size",
    attrs: {
      "row": "",
      "mandatory": false,
      "hide-details": ""
    },
    on: {
      "change": function($event) {
        return _vm.changeAssetType()
      }
    },
    model: {
      value: (_vm.lPpm.ppm_cat),
      callback: function($$v) {
        _vm.$set(_vm.lPpm, "ppm_cat", $$v)
      },
      expression: "lPpm.ppm_cat"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "Equipment",
      "value": "EQ"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Non-equipment",
      "value": "NE"
    }
  })], 1)], 1), _vm._v(" "), (_vm.lPpm.ppm_cat === 'EQ') ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Assets",
      "items": _vm.showNonCritical ? _vm.assetList : _vm.assetList.filter(function (rec) { return rec.is_critical; }),
      "item-value": "asset_id",
      "item-text": "asset_name_and_spec",
      "hide-details": "",
      "multiple": "",
      "small-chips": "",
      "clearable": "",
      "deletable-chips": "",
      "dense": ""
    },
    model: {
      value: (_vm.lPpm.asset_pair),
      callback: function($$v) {
        _vm.$set(_vm.lPpm, "asset_pair", $$v)
      },
      expression: "lPpm.asset_pair"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-right",
    attrs: {
      "xs2": ""
    }
  }, [_c('v-btn', {
    staticClass: "grey lighten-2 mt-2",
    attrs: {
      "icon": "",
      "to": {
        path: '/inventory'
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-checkbox', {
    staticClass: "ma-0 pa-0",
    attrs: {
      "label": "Show non-critical also",
      "hide-details": ""
    },
    model: {
      value: (_vm.showNonCritical),
      callback: function($$v) {
        _vm.showNonCritical = $$v
      },
      expression: "showNonCritical"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.lPpm.ppm_cat === 'NE') ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Enter non-equipment name",
      "hide-details": "",
      "maxlength": "100",
      "rules": [_vm.rules.required]
    },
    model: {
      value: (_vm.lPpm.noneq_name),
      callback: function($$v) {
        _vm.$set(_vm.lPpm, "noneq_name", $$v)
      },
      expression: "lPpm.noneq_name"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "PPM Title",
      "placeholder": "Enter the description of PPM activity",
      "hide-details": "",
      "maxlength": "100",
      "rules": [_vm.rules.required]
    },
    model: {
      value: (_vm.lPpm.activity_desc),
      callback: function($$v) {
        _vm.$set(_vm.lPpm, "activity_desc", $$v)
      },
      expression: "lPpm.activity_desc"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "rwo": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm3": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Frequency",
      "items": _vm.freqItems,
      "item-text": "freq",
      "item-value": "short_form",
      "rules": [_vm.rules.required],
      "hide-details": ""
    },
    model: {
      value: (_vm.lPpm.freq),
      callback: function($$v) {
        _vm.$set(_vm.lPpm, "freq", $$v)
      },
      expression: "lPpm.freq"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm2": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Starts from",
      "items": _vm.monthItem,
      "item-value": "value",
      "item-text": "name",
      "hide-details": ""
    },
    model: {
      value: (_vm.lPpm.month),
      callback: function($$v) {
        _vm.$set(_vm.lPpm, "month", $$v)
      },
      expression: "lPpm.month"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm7": ""
    }
  }, [_c('v-layout', {
    staticClass: "pa-0 pt-2 ml-1",
    attrs: {
      "align-center": ""
    }
  }, [_c('v-radio-group', {
    staticClass: "my-label-text-size",
    attrs: {
      "label": "Duration: ",
      "row": "",
      "mandatory": true,
      "hide-details": ""
    },
    on: {
      "change": function($event) {
        return _vm.$forceUpdate()
      }
    },
    model: {
      value: (_vm.lPpm.toYears),
      callback: function($$v) {
        _vm.$set(_vm.lPpm, "toYears", $$v)
      },
      expression: "lPpm.toYears"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "1 Year",
      "value": "1",
      "checked": "1"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "2 Years",
      "value": "2"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "3 Years",
      "value": "3"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-dialog', {
    ref: "scheduledDt",
    attrs: {
      "persistent": "",
      "lazy": "",
      "max-width": "290px",
      "return-value": _vm.lPpm.sched_dt
    },
    on: {
      "update:returnValue": function($event) {
        return _vm.$set(_vm.lPpm, "sched_dt", $event)
      },
      "update:return-value": function($event) {
        return _vm.$set(_vm.lPpm, "sched_dt", $event)
      }
    },
    model: {
      value: (_vm.scheduledDt),
      callback: function($$v) {
        _vm.scheduledDt = $$v
      },
      expression: "scheduledDt"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "Scheduled Date",
      "append-icon": "event",
      "readonly": "",
      "clearable": "",
      "hide-details": ""
    },
    slot: "activator",
    model: {
      value: (_vm.lPpm.sched_dt),
      callback: function($$v) {
        _vm.$set(_vm.lPpm, "sched_dt", $$v)
      },
      expression: "lPpm.sched_dt"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "scrollable": "",
      "show-week": _vm.showWeek,
      "first-day-of-week": "1"
    },
    model: {
      value: (_vm.lPpm.sched_dt),
      callback: function($$v) {
        _vm.$set(_vm.lPpm, "sched_dt", $$v)
      },
      expression: "lPpm.sched_dt"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.scheduledDt = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "accent"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.scheduledDt.save(_vm.lPpm.sched_dt)
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-combobox', {
    attrs: {
      "label": "Key staffs",
      "items": _vm.keyStaffLists,
      "item-text": "user_name",
      "item-value": "user_id",
      "hide-details": "",
      "rules": [_vm.rules.required]
    },
    on: {
      "change": function($event) {
        return _vm.ShowNonEMailIdsMsg()
      }
    },
    model: {
      value: (_vm.lPpm.key_staff_pair),
      callback: function($$v) {
        _vm.$set(_vm.lPpm, "key_staff_pair", $$v)
      },
      expression: "lPpm.key_staff_pair"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pt-2 primary--text"
  }, [_vm._v("\n                      Scheduled date is mandatory. Please make sure "), _c('strong', [_vm._v(" Date, Month and Year ")]), _vm._v(" for scheduled date. PPM entry will be scheduled based on scheduled date and frequency upto selected schedule duration.\n                    ")]), _vm._v(" "), (_vm.showMsg) ? _c('div', {
    staticClass: "pt-2"
  }, [_vm._v("\n                      Selected Staff will not get any notification as email is empty.\n                      Please update the staff details in BackBone to get the notifications.\n                    ")]) : _vm._e(), _vm._v(" "), _c('v-flex', {
    staticClass: "pl-0",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-radio-group', {
    staticClass: "pa-0 my-label-text-size",
    attrs: {
      "row": "",
      "mandatory": false,
      "hide-details": ""
    },
    on: {
      "change": function($event) {
        return _vm.$forceUpdate()
      }
    },
    model: {
      value: (_vm.lPpm.activity_by),
      callback: function($$v) {
        _vm.$set(_vm.lPpm, "activity_by", $$v)
      },
      expression: "lPpm.activity_by"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "In-house activity",
      "value": "I"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Vendor activity",
      "value": "V"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-btn', {
    on: {
      "click": function($event) {
        _vm.showCheckListDlg = true
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-2"
  }, [_vm._v("check")]), _vm._v("SOP CHECKLIST")], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.lAction = 'view'
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    staticClass: "accent",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.lAction === 'update') ? _c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-form', {
    ref: "lForm",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.saveChanges(_vm.lAction, _vm.lPpm.ppm_week)
      }
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm7": "",
      "mx-auto": ""
    }
  }, [_c('v-card-text', {
    staticClass: "px-2 pb-2 pt-0"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "pl-0",
    attrs: {
      "xs7": ""
    }
  }, [_c('v-radio-group', {
    staticClass: "pa-0 my-label-text-size",
    attrs: {
      "row": "",
      "disabled": _vm.lAction === 'update',
      "mandatory": false,
      "hide-details": ""
    },
    on: {
      "change": function($event) {
        return _vm.changeAssetType()
      }
    },
    model: {
      value: (_vm.lPpm.ppm_cat),
      callback: function($$v) {
        _vm.$set(_vm.lPpm, "ppm_cat", $$v)
      },
      expression: "lPpm.ppm_cat"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "Equipment",
      "value": "EQ"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Non-equipment",
      "value": "NE"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pt-4 font-weight-bold grey--text",
    attrs: {
      "xs2": ""
    }
  }, [_c('div', [_vm._v("PPM Id : " + _vm._s(_vm.lPpm.ppm_id))])]), _vm._v(" "), _c('v-flex', {
    staticClass: "pt-4 font-weight-bold grey--text",
    attrs: {
      "xs2": ""
    }
  }, [_c('div', [_vm._v("Seq Id : " + _vm._s(_vm.lPpm.seq_no))])]), _vm._v(" "), (_vm.lPpm.ppm_cat === 'EQ') ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Asset",
      "items": _vm.assetList,
      "item-value": "asset_id",
      "item-text": "asset_name_and_spec",
      "hide-details": "",
      "return-object": ""
    },
    model: {
      value: (_vm.lPpm.asset_pair),
      callback: function($$v) {
        _vm.$set(_vm.lPpm, "asset_pair", $$v)
      },
      expression: "lPpm.asset_pair"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.lPpm.ppm_cat === 'NE') ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Enter non-equipment name",
      "hide-details": "",
      "maxlength": "100",
      "rules": [_vm.rules.required]
    },
    model: {
      value: (_vm.lPpm.noneq_name),
      callback: function($$v) {
        _vm.$set(_vm.lPpm, "noneq_name", $$v)
      },
      expression: "lPpm.noneq_name"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Asset Tag",
      "hide-details": "",
      "disabled": ""
    },
    model: {
      value: (_vm.lPpm.asset_tag),
      callback: function($$v) {
        _vm.$set(_vm.lPpm, "asset_tag", $$v)
      },
      expression: "lPpm.asset_tag"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "PPM Title",
      "placeholder": "Enter the description of PPM activity",
      "hide-details": "",
      "maxlength": "100",
      "rules": [_vm.rules.required]
    },
    model: {
      value: (_vm.lPpm.activity_desc),
      callback: function($$v) {
        _vm.$set(_vm.lPpm, "activity_desc", $$v)
      },
      expression: "lPpm.activity_desc"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Frequency",
      "items": _vm.freqItems,
      "item-text": "freq",
      "item-value": "short_form",
      "hide-details": "",
      "dense": "",
      "disabled": _vm.lAction === 'update'
    },
    model: {
      value: (_vm.lPpm.freq),
      callback: function($$v) {
        _vm.$set(_vm.lPpm, "freq", $$v)
      },
      expression: "lPpm.freq"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-combobox', {
    attrs: {
      "label": "Key staffs",
      "items": _vm.keyStaffLists,
      "item-text": "user_name",
      "item-value": "user_id",
      "hide-details": ""
    },
    on: {
      "change": function($event) {
        return _vm.ShowNonEMailIdsMsg()
      }
    },
    model: {
      value: (_vm.lPpm.key_staff_pair),
      callback: function($$v) {
        _vm.$set(_vm.lPpm, "key_staff_pair", $$v)
      },
      expression: "lPpm.key_staff_pair"
    }
  })], 1), _vm._v(" "), (_vm.showMsg) ? _c('div', {
    staticClass: "pt-2"
  }, [_vm._v("\n                      Selected Staff will not get any notification as email is empty.\n                      Please update the staff details in BackBone to get the notifications.\n                    ")]) : _vm._e(), _vm._v(" "), _c('v-flex', {
    staticClass: "pl-0",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-radio-group', {
    staticClass: "pa-0 my-label-text-size",
    attrs: {
      "row": "",
      "mandatory": false,
      "hide-details": ""
    },
    on: {
      "change": function($event) {
        return _vm.$forceUpdate()
      }
    },
    model: {
      value: (_vm.lPpm.activity_by),
      callback: function($$v) {
        _vm.$set(_vm.lPpm, "activity_by", $$v)
      },
      expression: "lPpm.activity_by"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "In-house activity",
      "value": "I"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Vendor activity",
      "value": "V"
    }
  })], 1)], 1), _vm._v(" "), (_vm.lAction === 'update') ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-alert', {
    staticClass: "accent lighten-4 pa-2",
    attrs: {
      "outline": "",
      "color": "grey lighten-2",
      "value": "true"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    on: {
      "click": function($event) {
        _vm.showCheckListDlg = true
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-2"
  }, [_vm._v("check")]), _vm._v("\n                              SOP CHECKLIST (" + _vm._s(_vm.sopList.compChecklist) + "/" + _vm._s(_vm.sopList.length) + ") " + _vm._s(_vm.sopList.not_ok > 0 ? '[' + _vm.sopList.not_ok + ' NOT OK]' : _vm.sopList.ok > 0 ? '[ALL OK]' : '') + "\n                            ")], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Status",
      "items": ['Unscheduled', 'Scheduled', 'Completed'],
      "hide-details": ""
    },
    on: {
      "input": function($event) {
        return _vm.$forceUpdate()
      }
    },
    model: {
      value: (_vm.lPpm.ppm_status),
      callback: function($$v) {
        _vm.$set(_vm.lPpm, "ppm_status", $$v)
      },
      expression: "lPpm.ppm_status"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-dialog', {
    ref: "scheduledDt",
    attrs: {
      "persistent": "",
      "lazy": "",
      "max-width": "290px",
      "return-value": _vm.lPpm.sched_dt
    },
    on: {
      "update:returnValue": function($event) {
        return _vm.$set(_vm.lPpm, "sched_dt", $event)
      },
      "update:return-value": function($event) {
        return _vm.$set(_vm.lPpm, "sched_dt", $event)
      }
    },
    model: {
      value: (_vm.scheduledDt),
      callback: function($$v) {
        _vm.scheduledDt = $$v
      },
      expression: "scheduledDt"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "Scheduled Date",
      "append-icon": "event",
      "readonly": "",
      "clearable": "",
      "hide-details": "",
      "required": "",
      "disabled": _vm.lPpm.ppm_status === 'Unscheduled'
    },
    slot: "activator",
    model: {
      value: (_vm.lPpm.sched_dt),
      callback: function($$v) {
        _vm.$set(_vm.lPpm, "sched_dt", $$v)
      },
      expression: "lPpm.sched_dt"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "scrollable": "",
      "disabled": _vm.lPpm.ppm_status === 'Unscheduled',
      "show-week": _vm.showWeek,
      "first-day-of-week": "1"
    },
    model: {
      value: (_vm.lPpm.sched_dt),
      callback: function($$v) {
        _vm.$set(_vm.lPpm, "sched_dt", $$v)
      },
      expression: "lPpm.sched_dt"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.scheduledDt = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "accent"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.scheduledDt.save(_vm.lPpm.sched_dt)
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-dialog', {
    ref: "completedDt",
    attrs: {
      "persistent": "",
      "lazy": "",
      "max-width": "290px",
      "return-value": _vm.lPpm.comp_dt
    },
    on: {
      "update:returnValue": function($event) {
        return _vm.$set(_vm.lPpm, "comp_dt", $event)
      },
      "update:return-value": function($event) {
        return _vm.$set(_vm.lPpm, "comp_dt", $event)
      }
    },
    model: {
      value: (_vm.completedDt),
      callback: function($$v) {
        _vm.completedDt = $$v
      },
      expression: "completedDt"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "Completed Date",
      "append-icon": "event",
      "readonly": "",
      "clearable": "",
      "hide-details": "",
      "required": "",
      "disabled": _vm.lPpm.ppm_status === 'Unscheduled' || _vm.lPpm.ppm_status === 'Scheduled'
    },
    slot: "activator",
    model: {
      value: (_vm.lPpm.comp_dt),
      callback: function($$v) {
        _vm.$set(_vm.lPpm, "comp_dt", $$v)
      },
      expression: "lPpm.comp_dt"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "scrollable": "",
      "disabled": _vm.lPpm.ppm_status === 'Unscheduled' || _vm.lPpm.ppm_status === 'Scheduled',
      "first-day-of-week": "1",
      "show-week": _vm.showWeek
    },
    model: {
      value: (_vm.lPpm.comp_dt),
      callback: function($$v) {
        _vm.$set(_vm.lPpm, "comp_dt", $$v)
      },
      expression: "lPpm.comp_dt"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.completedDt = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "accent"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.completedDt.save(_vm.lPpm.comp_dt)
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1), _vm._v(" "), (_vm.lPpm.activity_by === 'I') ? _c('v-flex', {
    staticClass: "pt-0",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Technician",
      "items": _vm.mcList,
      "item-text": "user_name",
      "item-value": "user_id",
      "hide-details": ""
    },
    model: {
      value: (_vm.lPpm.staff_id),
      callback: function($$v) {
        _vm.$set(_vm.lPpm, "staff_id", $$v)
      },
      expression: "lPpm.staff_id"
    }
  })], 1)], 1)], 1) : _c('v-flex', {
    staticClass: "pt-0",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Vendor",
      "items": _vm.vendors,
      "item-value": "vendor_id",
      "item-text": "vendor_name",
      "hide-details": ""
    },
    model: {
      value: (_vm.lPpm.vendor_id),
      callback: function($$v) {
        _vm.$set(_vm.lPpm, "vendor_id", $$v)
      },
      expression: "lPpm.vendor_id"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('v-btn', {
    staticClass: "grey lighten-2 mt-2",
    attrs: {
      "icon": "",
      "to": {
        path: '/vendor'
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pt-0",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Enter Summary",
      "hide-details": "",
      "rules": [_vm.rules.required],
      "maxlength": "200"
    },
    model: {
      value: (_vm.lPpm.observ),
      callback: function($$v) {
        _vm.$set(_vm.lPpm, "observ", $$v)
      },
      expression: "lPpm.observ"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pl-0",
    attrs: {
      "xs12": ""
    }
  }, [_c('input', {
    ref: "fileInput",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": ".xls, .xlsx, .pdf, .doc, .docx, image/png, image/gif, image/jpeg",
      "multiple": ""
    },
    on: {
      "change": function($event) {
        return _vm.loadFilesFromFileBrowser(_vm.lPpm)
      }
    }
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.pickFile
    }
  }, [_c('v-icon', [_vm._v("attach_file")])], 1), _vm._v(" "), (_vm.lPpm.files && _vm.lPpm.files.filter(function (rec) { return rec.is_selected; }).length > 0) ? _c('span', _vm._l((_vm.lPpm.files.filter(function (rec) { return rec.is_selected; })), function(file, index) {
    return _c('span', {
      key: index
    }, [_c('v-chip', {
      attrs: {
        "close": ""
      },
      on: {
        "input": function($event) {
          return _vm.$forceUpdate()
        }
      },
      model: {
        value: (file.is_selected),
        callback: function($$v) {
          _vm.$set(file, "is_selected", $$v)
        },
        expression: "file.is_selected"
      }
    }, [_c('a', {
      staticStyle: {
        "text-decoration": "none"
      },
      attrs: {
        "href": _vm.config.FM_SPACES_BASE_URL + file.file_url,
        "download": ""
      }
    }, [_c('v-btn', {
      staticClass: "ml-0 pa-0 info lighten-1 grey--text text--lighten-4",
      attrs: {
        "small": "",
        "icon": ""
      }
    }, [_c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("file_download")])], 1)], 1), _vm._v(_vm._s(file.file_name))])], 1)
  }), 0) : _c('span', {
    staticClass: "caption black--text"
  }, [_vm._v("Attach report if any (upto 20MB)")])], 1)], 1)], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.lAction = 'view'
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.lAction === 'update') ? _c('v-btn', {
    on: {
      "click": function($event) {
        return _vm.deletePpm(_vm.lPpm)
      }
    }
  }, [_vm._v("delete")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    staticClass: "accent",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-bottom-sheet', {
    staticClass: "caption",
    attrs: {
      "inset": "",
      "max-width": "500px"
    },
    model: {
      value: (_vm.showFilter),
      callback: function($$v) {
        _vm.showFilter = $$v
      },
      expression: "showFilter"
    }
  }, [_c('v-card', [_c('v-card-text', [_c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Category ppp",
      "items": _vm.catList,
      "item-value": "asset_cat_id",
      "item-text": "asset_cat",
      "hide-details": "",
      "multiple": "",
      "small": "",
      "chips": "",
      "clearable": "",
      "dense": "",
      "return-object": ""
    },
    model: {
      value: (_vm.filterList.asset_cat_list),
      callback: function($$v) {
        _vm.$set(_vm.filterList, "asset_cat_list", $$v)
      },
      expression: "filterList.asset_cat_list"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-radio-group', {
    staticClass: "pa-0",
    attrs: {
      "row": "",
      "mandatory": false,
      "hide-details": ""
    },
    on: {
      "change": function($event) {
        return _vm.$forceUpdate()
      }
    },
    model: {
      value: (_vm.filterList.activity_by),
      callback: function($$v) {
        _vm.$set(_vm.filterList, "activity_by", $$v)
      },
      expression: "filterList.activity_by"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "In-house activity",
      "value": "I"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Vendor activity",
      "value": "V"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": "Critical asset",
      "hide-details": ""
    },
    model: {
      value: (_vm.filterList.is_critical),
      callback: function($$v) {
        _vm.$set(_vm.filterList, "is_critical", $$v)
      },
      expression: "filterList.is_critical"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": "Non-equipment category",
      "hide-details": ""
    },
    model: {
      value: (_vm.filterList.is_ne),
      callback: function($$v) {
        _vm.$set(_vm.filterList, "is_ne", $$v)
      },
      expression: "filterList.is_ne"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showFilter = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": _vm.clearFilter
    }
  }, [_vm._v("Clear all")]), _vm._v(" "), _c('v-btn', {
    staticClass: "ma-0",
    attrs: {
      "flat": "",
      "color": "accent"
    },
    on: {
      "click": _vm.applyFilter
    }
  }, [_vm._v("Apply")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "scrollable": "",
      "max-width": "800px"
    },
    model: {
      value: (_vm.showCheckListDlg),
      callback: function($$v) {
        _vm.showCheckListDlg = $$v
      },
      expression: "showCheckListDlg"
    }
  }, [_c('v-card', [_c('v-card-text', {
    staticClass: "py-2"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.lAction === 'update') ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    staticClass: "pa-0 mt-1",
    attrs: {
      "append-icon": "search",
      "placeholder": _vm.$vuetify.breakpoint.smAndUp ? 'Search by CheckList item, Observation, etc.' : 'Search',
      "single-line": "",
      "outline": "",
      "hide-details": "",
      "clearable": ""
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-download-as', {
    attrs: {
      "headers": _vm.sopUpdateHead,
      "items": _vm.sopList,
      "title": "SOP CheckList",
      "landscape": true
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [(_vm.sopList.length > 0) ? _c('v-btn', {
    staticClass: "text-xs-left accent",
    attrs: {
      "flat": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.prepareSopChecklistTimeLine()
      }
    }
  }, [_vm._v("Timeline")]) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-right pa-0",
    attrs: {
      "xs6": ""
    }
  }, [_c('v-btn', {
    staticClass: "accent",
    attrs: {
      "flat": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.prepareSopChecklist()
      }
    }
  }, [_vm._v("Add new")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-data-table', {
    staticClass: "tblSopChecklist elevation-1",
    attrs: {
      "headers": _vm.lAction === 'create' ? _vm.sopHead : _vm.sopUpdateHead,
      "items": _vm.sopList,
      "hide-actions": "",
      "disable-initial-sort": "",
      "search": _vm.search
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', [(_vm.lAction === 'update') ? _c('td', {
          staticClass: "handle pl-1 pr-0"
        }, [_c('v-icon', {
          attrs: {
            "small": ""
          }
        }, [_vm._v("zoom_out_map")])], 1) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.cl_item))]), _vm._v(" "), (_vm.lAction === 'update') ? _c('td', [_c('v-select', {
          staticClass: "caption",
          attrs: {
            "items": ['', 'OK', 'NOT OK'],
            "label": "Result",
            "hide-details": "",
            "dense": ""
          },
          model: {
            value: (props.item.cl_result),
            callback: function($$v) {
              _vm.$set(props.item, "cl_result", $$v)
            },
            expression: "props.item.cl_result"
          }
        })], 1) : _vm._e(), _vm._v(" "), (_vm.lAction === 'update') ? _c('td', {
          staticStyle: {
            "cursor": "pointer"
          },
          on: {
            "click": function($event) {
              return _vm.LoadImages(props.item)
            }
          }
        }, [_c('v-badge', {
          attrs: {
            "overlap": "",
            "color": "info"
          },
          scopedSlots: _vm._u([{
            key: "badge",
            fn: function() {
              return [_c('span', {
                staticClass: "caption white--text"
              }, [_vm._v(_vm._s(props.item.tot_files))])]
            },
            proxy: true
          }], null, true)
        }, [_vm._v(" "), _c('v-icon', {
          staticClass: "pa-2",
          attrs: {
            "small": ""
          }
        }, [_vm._v("attach_file")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.lAction === 'update') ? _c('td', [_c('v-text-field', {
          attrs: {
            "label": "Observation",
            "maxlength": "150",
            "hide-details": ""
          },
          model: {
            value: (props.item.cl_observ),
            callback: function($$v) {
              _vm.$set(props.item, "cl_observ", $$v)
            },
            expression: "props.item.cl_observ"
          }
        })], 1) : _vm._e(), _vm._v(" "), _c('td', [_c('v-menu', {
          staticClass: "mt-0",
          attrs: {
            "close-on-content-click": false,
            "top": "",
            "right": ""
          }
        }, [_c('span', {
          attrs: {
            "slot": "activator"
          },
          slot: "activator"
        }, [_c('v-btn', {
          attrs: {
            "slot": "activator",
            "icon": ""
          },
          slot: "activator"
        }, [_c('v-icon', [_vm._v("more_vert")])], 1)], 1), _vm._v(" "), _c('v-list', {
          staticClass: "py-0"
        }, [(_vm.lAction === 'update') ? _c('v-list-tile', {
          on: {
            "click": function($event) {
              return _vm.prepareUploadFile(props.item)
            }
          }
        }, [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("attach_file")])], 1), _vm._v(" "), _c('v-list-tile-title', [_vm._v("Attach photo")])], 1) : _vm._e(), _vm._v(" "), (_vm.lAction === 'update') ? _c('v-divider') : _vm._e(), _vm._v(" "), (_vm.lAction === 'update') ? _c('v-list-tile', {
          on: {
            "click": function($event) {
              return _vm.prepareUpdateChecklist(props.item)
            }
          }
        }, [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("edit")])], 1), _vm._v(" "), _c('v-list-tile-title', [_vm._v("Edit")])], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile', {
          on: {
            "click": function($event) {
              return _vm.deleteChecklist(props.item)
            }
          }
        }, [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("delete")])], 1), _vm._v(" "), _c('v-list-tile-title', [_vm._v("Delete")])], 1)], 1)], 1)], 1)])]
      }
    }])
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "px-2 pb-2"
  }, [_c('v-btn', {
    staticClass: "accent--text",
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.prepareUpload()
      }
    }
  }, [_vm._v("Upload Checklists")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.lAction === 'update') ? _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.updateChecklist(_vm.sopList)
      }
    }
  }, [_vm._v("save & close")]) : _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.showCheckListDlg = false
      }
    }
  }, [_vm._v("close")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "500px"
    },
    model: {
      value: (_vm.showEditChecklist),
      callback: function($$v) {
        _vm.showEditChecklist = $$v
      },
      expression: "showEditChecklist"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "py-3 title grey lighten-4"
  }, [(_vm.lAction === 'create') ? _c('div', [_vm._v("\n            Create Checklist\n          ")]) : (_vm.lAction === 'update' && _vm.lSubAction !== 'attach') ? _c('div', [_vm._v("\n            Edit Checklist\n          ")]) : _c('div', [_vm._v("\n            Upload Photo\n          ")])]), _vm._v(" "), _c('v-card-text', {
    staticClass: "py-2"
  }, [(_vm.lAction === 'create' || (_vm.lAction === 'update' && _vm.lSubAction !== 'attach')) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Checklist Item",
      "rules": [_vm.rules.required],
      "maxlength": "150",
      "hide-details": ""
    },
    model: {
      value: (_vm.lSop.cl_item),
      callback: function($$v) {
        _vm.$set(_vm.lSop, "cl_item", $$v)
      },
      expression: "lSop.cl_item"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.lSubAction === 'attach') ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('input', {
    ref: "fileInput",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": "image/png, image/gif, image/jpeg",
      "multiple": ""
    },
    on: {
      "change": function($event) {
        return _vm.loadFilesFromFileBrowser(_vm.lSop)
      }
    }
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.pickFile
    }
  }, [_c('v-icon', [_vm._v("attach_file")])], 1), _vm._v(" "), (_vm.lSop.files && _vm.lSop.files.filter(function (rec) { return rec.is_selected; }).length > 0) ? _c('span', _vm._l((_vm.lSop.files.filter(function (rec) { return rec.is_selected; })), function(file, index) {
    return _c('span', {
      key: index
    }, [_c('v-chip', {
      attrs: {
        "close": ""
      },
      on: {
        "input": function($event) {
          return _vm.$forceUpdate()
        }
      },
      model: {
        value: (file.is_selected),
        callback: function($$v) {
          _vm.$set(file, "is_selected", $$v)
        },
        expression: "file.is_selected"
      }
    }, [_vm._v(_vm._s(file.file_name))])], 1)
  }), 0) : _c('span', {
    staticClass: "caption black--text"
  }, [_vm._v("Attach photos if any (upto 20MB)")])], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.showEditChecklist = false;
        _vm.lSubAction = ''
      }
    }
  }, [_vm._v("close")]), _vm._v(" "), _c('v-btn', {
    staticClass: "accent--text",
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.saveChecklist()
      }
    }
  }, [_vm._v("save")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "700px"
    },
    model: {
      value: (_vm.showChecklistUpload),
      callback: function($$v) {
        _vm.showChecklistUpload = $$v
      },
      expression: "showChecklistUpload"
    }
  }, [(_vm.lMAction === 'upload') ? _c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "title grey lighten-4"
  }, [_vm._v("\n                Upload SOP CheckList\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "mt-3 text-xs-center primary--text",
    staticStyle: {
      "font-family": "'Satisfy', cursive",
      "font-size": "200%",
      "font-weight": "normal"
    }
  }, [_vm._v("In just 4 steps")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "subheading"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-chip', {
    staticClass: "primary--text",
    attrs: {
      "small": "",
      "disabled": "",
      "outline": ""
    }
  }, [_vm._v("Step 1")]), _vm._v(" "), _c('span', [_vm._v("Download template")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('form', {
    attrs: {
      "method": "get",
      "action": "../static/files/Smartility_SOP_List_Template.xlsx"
    }
  }, [_c('v-btn', {
    staticClass: "mt-0 mb-0",
    attrs: {
      "type": "submit",
      "small": ""
    }
  }, [_c('v-icon', [_vm._v("file_download")])], 1)], 1)])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-chip', {
    staticClass: "primary--text",
    attrs: {
      "small": "",
      "disabled": "",
      "outline": ""
    }
  }, [_vm._v("Step 2")]), _vm._v(" "), _c('span', [_vm._v("Fill-in details as guided in template")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-chip', {
    staticClass: "primary--text",
    attrs: {
      "small": "",
      "disabled": "",
      "outline": ""
    }
  }, [_vm._v("Step 3")]), _vm._v(" "), _c('span', [_vm._v("Save as CSV "), _c('span', {
    staticClass: "caption"
  }, [_vm._v("(Comma delimited)")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "caption grey--text pl-4 ml-4"
  }, [_c('span', {
    staticClass: "ml-4"
  }, [_vm._v("Go with OK/Yes when prompted while saving")])])])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-chip', {
    staticClass: "primary--text",
    attrs: {
      "small": "",
      "disabled": "",
      "outline": ""
    }
  }, [_vm._v("Step 4")]), _vm._v(" "), _c('span', [_vm._v("Upload the CSV file")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('v-btn', {
    staticClass: "mt-0 mb-0 accent",
    attrs: {
      "small": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.promptUpload($event)
      }
    }
  }, [_c('v-icon', [_vm._v("file_upload")])], 1)], 1), _vm._v(" "), _c('input', {
    ref: "ipFile",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": ".csv"
    },
    on: {
      "change": function($event) {
        return _vm.validateFile()
      }
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "mt-3 text-xs-center primary--text",
    staticStyle: {
      "font-family": "'Satisfy', cursive",
      "font-size": "200%",
      "font-weight": "normal"
    }
  }, [_vm._v("Uniservice takes care of rest")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-chip', {
    staticClass: "primary--text",
    attrs: {
      "small": "",
      "disabled": "",
      "outline": ""
    }
  }, [_vm._v("Step 4")]), _vm._v(" "), _c('span', [_vm._v("Validate your information")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-chip', {
    staticClass: "primary--text",
    attrs: {
      "small": "",
      "disabled": "",
      "outline": ""
    }
  }, [_vm._v("Step 5")]), _vm._v(" "), _c('span', [_vm._v("Create SOP Checklist")])], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "pt-0"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cancelChanges($event)
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.lMAction === 'validate') ? _c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "title grey lighten-4"
  }, [_vm._v("\n                Upload SOP CheckList\n              ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "text-xs-center pl-2 pr-2"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md9": "",
      "mx-auto": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "info--text mb-2",
    attrs: {
      "xs12": ""
    }
  }, [(_vm.validateInProgress) ? _c('span', [_vm._v("Loading and validating the file...")]) : _vm._e(), _vm._v(" "), (_vm.validFile && !_vm.validateInProgress) ? _c('span', [_vm._v("File validation is successfull "), _c('v-icon', {
    staticClass: "success--text"
  }, [_vm._v("check")])], 1) : _vm._e(), _vm._v(" "), (!_vm.validFile) ? _c('span', [_vm._v("File validation is failed "), _c('v-icon', {
    staticClass: "error--text"
  }, [_vm._v("close")])], 1) : _vm._e(), _vm._v(" "), (!_vm.validFile && _vm.headerIssue) ? _c('span', {
    staticClass: "error--text"
  }, [_c('br'), _vm._v("Invalid column headers, please ensure names and count are matching as per the template")]) : _vm._e(), _vm._v(" "), (!_vm.validFile && !_vm.headerIssue) ? _c('span', {
    staticClass: "error--text"
  }, [_c('br'), _vm._v("One or more invalid records, review the table below."), _c('br'), _vm._v("Click on the errored row to know more info.")]) : _vm._e(), _vm._v(" "), (!_vm.totFail && !_vm.loadInProgress) ? _c('span', [_vm._v("SOP checklist upload was successfull"), _c('v-icon', {
    staticClass: "success--text"
  }, [_vm._v("check")])], 1) : _vm._e(), _vm._v(" "), (!_vm.totLoaded && _vm.totFail && !_vm.loadInProgress) ? _c('span', [_c('br'), _vm._v("SOP checklist has failed"), _c('v-icon', {
    staticClass: "error--text"
  }, [_vm._v("close")])], 1) : _vm._e(), _vm._v(" "), (_vm.totLoaded && _vm.totFail && !_vm.loadInProgress) ? _c('span', [_c('br'), _vm._v("SOP checklist partially failed"), _c('v-icon', {
    staticClass: "warning--text"
  }, [_vm._v("close")])], 1) : _vm._e(), _vm._v(" "), (_vm.totFail && !_vm.loadInProgress) ? _c('span', {
    staticClass: "error--text"
  }, [_c('br'), _vm._v("One or more failed records, review the table below."), _c('br'), _vm._v("Click on the errored row to know more info.")]) : _vm._e()]), _vm._v(" "), (_vm.totRecs) ? _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "color": "info",
      "value": _vm.readyForLoad ? 100 : (_vm.recsLoaded.length / _vm.totRecs * 100),
      "size": 50,
      "width": 7
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.readyForLoad ? _vm.totValid : _vm.recsLoaded.length) + "\n                        ")]), _vm._v(" "), _c('br'), _c('div', {
    staticClass: "caption grey--text"
  }, [_vm._v("Records")])], 1) : _vm._e(), _vm._v(" "), (_vm.totRecs) ? _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "color": "success",
      "value": (_vm.totValid / _vm.totRecs * 100),
      "size": 50,
      "width": 7
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.readyForLoad ? _vm.totLoaded : _vm.totValid) + "\n                        ")]), _vm._v(" "), _c('br'), _c('div', {
    staticClass: "caption grey--text"
  }, [_vm._v(_vm._s(_vm.readyForLoad ? 'Loaded' : 'Valid'))])], 1) : _vm._e(), _vm._v(" "), (_vm.totRecs) ? _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "color": "error",
      "value": (_vm.totInvalid / _vm.totRecs * 100),
      "size": 50,
      "width": 7
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.readyForLoad ? _vm.totFail : _vm.totInvalid) + "\n                        ")]), _vm._v(" "), _c('br'), _c('div', {
    staticClass: "caption grey--text"
  }, [_vm._v(_vm._s(_vm.readyForLoad ? 'Failed' : 'Invalid'))])], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "small": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.lMAction = 'upload'
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.totValid > 0) ? _c('v-btn', {
    staticClass: "accent",
    attrs: {
      "small": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.uploadSopChecklist($event)
      }
    }
  }, [_vm._v("Process the valid records")]) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    staticClass: "mt-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-data-table', {
    staticClass: "elevation-3 text-xs-left",
    attrs: {
      "headers": _vm.loadHeadSm,
      "items": _vm.recsLoaded,
      "hide-actions": "",
      "disable-initial-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          class: (props.item.error ? (props.item.load_status === 'Failed' ? 'error' : 'error--text') : (props.item.load_status === 'Loaded' ? 'success' : '')),
          on: {
            "click": function($event) {
              props.item.error ? _vm.showError(props.item.error) : ''
            }
          }
        }, [_c('td', [_vm._v(_vm._s(props.item.cl_item))])])]
      }
    }], null, false, 1605845768)
  })], 1)], 1)], 1), _vm._v(" "), (false) ? _c('v-card-actions', {
    staticClass: "pt-0"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cancelChanges($event)
      }
    }
  }, [_vm._v("Cancel")])], 1) : _vm._e()], 1)], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "800px"
    },
    model: {
      value: (_vm.showSopImages),
      callback: function($$v) {
        _vm.showSopImages = $$v
      },
      expression: "showSopImages"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "title grey lighten-4 pr-0 py-2"
  }, [_c('span', [_vm._v(_vm._s(_vm.sopFiles.cl_item))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.showSopImages = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), (_vm.sopFiles.files && _vm.sopFiles.files.filter(function (rec) { return rec.is_selected; }).length > 0) ? _c('v-card-text', {
    staticClass: "pa-2"
  }, [_c('div', {
    directives: [{
      name: "viewer",
      rawName: "v-viewer",
      value: (_vm.options),
      expression: "options"
    }],
    staticClass: "clearfix"
  }, [_vm._l((_vm.sopFiles.files), function(file, index) {
    return [_c('img', {
      key: index,
      staticClass: "ma-1",
      staticStyle: {
        "display": "inline-block",
        "cursor": "pointer"
      },
      attrs: {
        "width": "180px",
        "src": _vm.config.FM_SPACES_BASE_URL + file.file_url,
        "data-source": _vm.config.FM_SPACES_BASE_URL + file.file_url
      }
    })]
  })], 2)]) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "600px"
    },
    model: {
      value: (_vm.showTimeline),
      callback: function($$v) {
        _vm.showTimeline = $$v
      },
      expression: "showTimeline"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "pa-0 title grey lighten-4"
  }, [_c('div', {
    staticClass: "px-2"
  }, [_vm._v("Timeline")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showTimeline = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-2"
  }, [_c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.timelineHead,
      "items": _vm.lChecklistDetails,
      "hide-actions": "",
      "disable-initial-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', [_c('td', [_vm._v(_vm._s(props.item.cl_item))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.cust_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.cl_result))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.cl_observ))])])]
      }
    }])
  })], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "500px"
    },
    model: {
      value: (_vm.showSerHist),
      callback: function($$v) {
        _vm.showSerHist = $$v
      },
      expression: "showSerHist"
    }
  }, [(_vm.lSHAction === 'view') ? _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "pa-2 subheading font-weight-bold grey lighten-4"
  }, [_vm._v("\n          " + _vm._s(_vm.assetDet.asset_cat + ':' + _vm.assetDet.asset_name + ' (Service history)') + "\n          "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showSerHist = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-flex', {
    staticClass: "mx-auto",
    attrs: {
      "xs12": "",
      "sm9": "",
      "md12": ""
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "mb-0",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "color": "accent",
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.prepareCreateServiceHist(_vm.assetDet)
      }
    }
  }, [_vm._v("Add New")]), _vm._v(" "), _c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.$vuetify.breakpoint.smAndUp ? _vm.assHistHead : _vm.assHistHeadsm,
      "items": _vm.histList,
      "hide-actions": "",
      "disable-initial-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          on: {
            "click": function($event) {
              return _vm.prepareEditHist(props.item)
            }
          }
        }, [_c('td', [_vm._v(_vm._s(_vm.handy.formatDate(props.item.service_hist_dt)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.service_hist_desc))]), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('td', [_vm._v(_vm._s(props.item.service_hist_cost ? _vm.handy.formatCur(props.item.service_hist_cost) : ''))]) : _vm._e()])]
      }
    }], null, false, 241459489)
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.lSHAction === 'create' || _vm.lSHAction === 'update') ? _c('v-container', {
    staticClass: "pa-0"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-form', {
    ref: "shForm",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.saveServiceHistory(_vm.lSHAction)
      }
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "pa-1 subheading font-weight-bold grey lighten-4"
  }, [_vm._v("\n                  " + _vm._s(_vm.assetDet.asset_name) + "\n                  "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.lSHAction = 'view'
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "subheading font-weight-bold pb-0"
  }, [_vm._v("\n                  " + _vm._s(_vm.handy.startWithUpper(_vm.lSHAction) + ' Service History') + "\n                ")]), _vm._v(" "), _c('v-card-text', [_c('v-flex', {
    staticClass: "mx-auto",
    attrs: {
      "xs12": "",
      "md11": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-dialog', {
    ref: "dlgservicehistDt",
    staticClass: "pt-0",
    attrs: {
      "persistent": "",
      "lazy": "",
      "max-width": "290px",
      "return-value": _vm.lHist.service_hist_dt
    },
    on: {
      "update:returnValue": function($event) {
        return _vm.$set(_vm.lHist, "service_hist_dt", $event)
      },
      "update:return-value": function($event) {
        return _vm.$set(_vm.lHist, "service_hist_dt", $event)
      }
    },
    model: {
      value: (_vm.dlgservicehistDt),
      callback: function($$v) {
        _vm.dlgservicehistDt = $$v
      },
      expression: "dlgservicehistDt"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "Service date",
      "append-icon": "event",
      "readonly": "",
      "hide-details": ""
    },
    slot: "activator",
    model: {
      value: (_vm.lHist.service_hist_dt),
      callback: function($$v) {
        _vm.$set(_vm.lHist, "service_hist_dt", $$v)
      },
      expression: "lHist.service_hist_dt"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "scrollable": "",
      "first-day-of-week": "1"
    },
    model: {
      value: (_vm.lHist.service_hist_dt),
      callback: function($$v) {
        _vm.$set(_vm.lHist, "service_hist_dt", $$v)
      },
      expression: "lHist.service_hist_dt"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.dlgservicehistDt = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "accent"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.dlgservicehistDt.save(_vm.lHist.service_hist_dt)
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Service description",
      "rules": [_vm.rules.required],
      "hide-details": "",
      "maxlength": "1000"
    },
    model: {
      value: (_vm.lHist.service_hist_desc),
      callback: function($$v) {
        _vm.$set(_vm.lHist, "service_hist_desc", $$v)
      },
      expression: "lHist.service_hist_desc"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Service cost",
      "rules": [_vm.rules.required],
      "hide-details": "",
      "type": "number"
    },
    model: {
      value: (_vm.lHist.service_hist_cost),
      callback: function($$v) {
        _vm.$set(_vm.lHist, "service_hist_cost", $$v)
      },
      expression: "lHist.service_hist_cost"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-combobox', {
    attrs: {
      "label": "Choose vendor",
      "items": _vm.vendors.map(function (rec) { return rec.vendor_name; }),
      "maxlength": "50",
      "hide-details": "",
      "clearable": ""
    },
    on: {
      "input": function($event) {
        return _vm.findVendor(_vm.lHist)
      }
    },
    model: {
      value: (_vm.lHist.vendor_name),
      callback: function($$v) {
        _vm.$set(_vm.lHist, "vendor_name", $$v)
      },
      expression: "lHist.vendor_name"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('v-dialog', {
    ref: "dlgnextservicehistDt",
    staticClass: "pt-0",
    attrs: {
      "persistent": "",
      "lazy": "",
      "max-width": "290px",
      "return-value": _vm.lHist.next_service_due_dt
    },
    on: {
      "update:returnValue": function($event) {
        return _vm.$set(_vm.lHist, "next_service_due_dt", $event)
      },
      "update:return-value": function($event) {
        return _vm.$set(_vm.lHist, "next_service_due_dt", $event)
      }
    },
    model: {
      value: (_vm.dlgnextservicehistDt),
      callback: function($$v) {
        _vm.dlgnextservicehistDt = $$v
      },
      expression: "dlgnextservicehistDt"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "Next service due date",
      "append-icon": "event",
      "readonly": "",
      "hide-details": ""
    },
    slot: "activator",
    model: {
      value: (_vm.lHist.next_service_due_dt),
      callback: function($$v) {
        _vm.$set(_vm.lHist, "next_service_due_dt", $$v)
      },
      expression: "lHist.next_service_due_dt"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "scrollable": "",
      "min": _vm.today,
      "first-day-of-week": "1"
    },
    model: {
      value: (_vm.lHist.next_service_due_dt),
      callback: function($$v) {
        _vm.$set(_vm.lHist, "next_service_due_dt", $$v)
      },
      expression: "lHist.next_service_due_dt"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.dlgnextservicehistDt = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "accent"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.dlgnextservicehistDt.save(_vm.lHist.next_service_due_dt)
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.cancelChangesServHist($event)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.lSHAction === 'update') ? _c('v-btn', {
    attrs: {
      "flat": "",
      "disabled": _vm.beingSaved
    },
    on: {
      "click": function($event) {
        return _vm.deleteServiceHist(_vm.lHist)
      }
    }
  }, [_vm._v("Delete")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "type": "submit",
      "color": "accent",
      "disabled": _vm.beingSaved
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), (_vm.lAction === 'upload') ? _c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "title pa-0 pl-3"
  }, [_vm._v("\n              Upload PPM Planner List\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "mt-3 text-xs-center primary--text",
    staticStyle: {
      "font-family": "'Satisfy', cursive",
      "font-size": "200%",
      "font-weight": "normal"
    }
  }, [_vm._v("In just 4 steps")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "subheading"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-chip', {
    staticClass: "primary--text",
    attrs: {
      "small": "",
      "disabled": "",
      "outline": ""
    }
  }, [_vm._v("Step 1")]), _vm._v(" "), _c('span', [_vm._v("Download template")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('form', {
    attrs: {
      "method": "get",
      "action": "../static/files/Smartility_Ppm_Planner_Template.xlsx"
    }
  }, [_c('v-btn', {
    staticClass: "mt-0 mb-0",
    attrs: {
      "type": "submit",
      "small": ""
    }
  }, [_c('v-icon', [_vm._v("file_download")])], 1)], 1)])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-chip', {
    staticClass: "primary--text",
    attrs: {
      "small": "",
      "disabled": "",
      "outline": ""
    }
  }, [_vm._v("Step 2")]), _vm._v(" "), _c('span', [_vm._v("Fill-in details as guided in template")]), _vm._v(" "), (_vm.lAction === 'upload') ? _c('div', {
    staticClass: "caption grey--text pl-4 ml-4"
  }, [_c('span', {
    staticClass: "ml-4"
  }, [_vm._v("Tip-1: "), _c('a', {
    staticStyle: {
      "text-decoration": "underline"
    },
    on: {
      "click": _vm.LoadKeyStaffIdList
    }
  }, [_vm._v("list of Key Staffs")])]), _vm._v(" "), _c('span', {
    staticClass: "ml-4"
  }, [_vm._v("Tip-2: "), _c('a', {
    staticStyle: {
      "text-decoration": "underline"
    },
    on: {
      "click": _vm.LoadAssetDetailsList
    }
  }, [_vm._v("Asset Details")])])]) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-chip', {
    staticClass: "primary--text",
    attrs: {
      "small": "",
      "disabled": "",
      "outline": ""
    }
  }, [_vm._v("Step 3")]), _vm._v(" "), _c('span', [_vm._v("Save as CSV "), _c('span', {
    staticClass: "caption"
  }, [_vm._v("(Comma delimited)")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "caption grey--text pl-4 ml-4"
  }, [_c('span', {
    staticClass: "ml-4"
  }, [_vm._v("Go with OK/Yes when prompted while saving")])])])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-chip', {
    staticClass: "primary--text",
    attrs: {
      "small": "",
      "disabled": "",
      "outline": ""
    }
  }, [_vm._v("Step 4")]), _vm._v(" "), _c('span', [_vm._v("Upload the CSV file")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('v-btn', {
    staticClass: "mt-0 mb-0 accent",
    attrs: {
      "small": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.promptUpload($event)
      }
    }
  }, [_c('v-icon', [_vm._v("file_upload")])], 1)], 1), _vm._v(" "), _c('input', {
    ref: "ipFile",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": ".csv"
    },
    on: {
      "change": function($event) {
        return _vm.validatePPMFile()
      }
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "mt-3 text-xs-center primary--text",
    staticStyle: {
      "font-family": "'Satisfy', cursive",
      "font-size": "200%",
      "font-weight": "normal"
    }
  }, [_vm._v("Uniservice takes care of rest")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-chip', {
    staticClass: "primary--text",
    attrs: {
      "small": "",
      "disabled": "",
      "outline": ""
    }
  }, [_vm._v("Step 4")]), _vm._v(" "), _c('span', [_vm._v("Validate your information")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-chip', {
    staticClass: "primary--text",
    attrs: {
      "small": "",
      "disabled": "",
      "outline": ""
    }
  }, [_vm._v("Step 5")]), _vm._v(" "), _c('span', [_vm._v("Create PPM Planner List")])], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "pt-0 pr-4"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    nativeOn: {
      "click": function($event) {
        _vm.lAction = 'view'
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "650px"
    },
    model: {
      value: (_vm.showKeyStaffIdList),
      callback: function($$v) {
        _vm.showKeyStaffIdList = $$v
      },
      expression: "showKeyStaffIdList"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "grey lighten-2 py-2",
    staticStyle: {
      "font-size": "17px"
    }
  }, [_vm._v("\n          Key Staffs\n          "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.showKeyStaffIdList = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    staticClass: "text-xs-right pa-0",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-download-as', {
    attrs: {
      "headers": _vm.keyStaffHead,
      "items": _vm.keyStaffLists,
      "title": "Key Staffs List",
      "landscape": true,
      "fontsize": 8
    }
  })], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.keyStaffHead,
      "items": _vm.keyStaffLists,
      "hide-actions": "",
      "dense": "",
      "disable-initial-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', [_c('td', [_vm._v(_vm._s(props.item.user_id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.user_name))])])]
      }
    }])
  })], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "650px"
    },
    model: {
      value: (_vm.showAssetDetailsList),
      callback: function($$v) {
        _vm.showAssetDetailsList = $$v
      },
      expression: "showAssetDetailsList"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "grey lighten-2 py-2",
    staticStyle: {
      "font-size": "17px"
    }
  }, [_vm._v("\n          Asset List Details\n          "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.showAssetDetailsList = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    staticClass: "text-xs-right pa-0",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-download-as', {
    attrs: {
      "headers": _vm.assetListHead,
      "items": _vm.assetList,
      "title": "Asset List",
      "landscape": true,
      "fontsize": 8
    }
  })], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.assetListHead,
      "items": _vm.assetList,
      "hide-actions": "",
      "disable-initial-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', [_c('td', [_vm._v(_vm._s(props.item.assettype))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.asset_id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.asset_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.asset_tag))])])]
      }
    }])
  })], 1)], 1)], 1), _vm._v(" "), (_vm.lAction === 'validate') ? _c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "grid-list-md": "",
      "max-width": "500px"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "title pa-0 pl-3"
  }, [_vm._v("\n              Upload PPM List\n            ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "text-xs-center pl-2 pr-2"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md9": "",
      "mx-auto": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "info--text mb-2",
    attrs: {
      "xs12": ""
    }
  }, [(_vm.validateInProgress) ? _c('span', [_vm._v("Loading and validating the file...")]) : _vm._e(), _vm._v(" "), (_vm.validFile && !_vm.validateInProgress) ? _c('span', [_vm._v("File validation is successfull "), _c('v-icon', {
    staticClass: "success--text"
  }, [_vm._v("check")])], 1) : _vm._e(), _vm._v(" "), (!_vm.validFile) ? _c('span', [_vm._v("File validation is failed "), _c('v-icon', {
    staticClass: "error--text"
  }, [_vm._v("close")])], 1) : _vm._e(), _vm._v(" "), (!_vm.validFile && _vm.headerIssue) ? _c('span', {
    staticClass: "error--text"
  }, [_c('br'), _vm._v("Invalid column headers, please ensure names and count are matching as per the template")]) : _vm._e(), _vm._v(" "), (!_vm.validFile && !_vm.headerIssue) ? _c('span', {
    staticClass: "error--text"
  }, [_c('br'), _vm._v("One or more invalid records, review the table below."), _c('br'), _vm._v("Click on the errored row to know more info.")]) : _vm._e(), _vm._v(" "), (!_vm.totFail && !_vm.loadInProgress) ? _c('span', [_vm._v("Asset list upload was successfull"), _c('v-icon', {
    staticClass: "success--text"
  }, [_vm._v("check")])], 1) : _vm._e(), _vm._v(" "), (!_vm.totLoaded && _vm.totFail && !_vm.loadInProgress) ? _c('span', [_c('br'), _vm._v("Asset list upload has failed"), _c('v-icon', {
    staticClass: "error--text"
  }, [_vm._v("close")])], 1) : _vm._e(), _vm._v(" "), (_vm.totLoaded && _vm.totFail && !_vm.loadInProgress) ? _c('span', [_c('br'), _vm._v("Asset list upload partially failed"), _c('v-icon', {
    staticClass: "warning--text"
  }, [_vm._v("close")])], 1) : _vm._e(), _vm._v(" "), (_vm.totFail && !_vm.loadInProgress) ? _c('span', {
    staticClass: "error--text"
  }, [_c('br'), _vm._v("One or more failed records, review the table below."), _c('br'), _vm._v("Click on the errored row to know more info.")]) : _vm._e()]), _vm._v(" "), (_vm.totRecs) ? _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "color": "info",
      "value": _vm.readyForLoad ? 100 : (_vm.recsLoaded.length / _vm.totRecs * 100),
      "size": 50,
      "width": 7
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.readyForLoad ? _vm.totValid : _vm.recsLoaded.length) + "\n                      ")]), _vm._v(" "), _c('br'), _c('div', {
    staticClass: "caption grey--text"
  }, [_vm._v("Records")])], 1) : _vm._e(), _vm._v(" "), (_vm.totRecs) ? _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "color": "success",
      "value": (_vm.totValid / _vm.totRecs * 100),
      "size": 50,
      "width": 7
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.readyForLoad ? _vm.totLoaded : _vm.totValid) + "\n                      ")]), _vm._v(" "), _c('br'), _c('div', {
    staticClass: "caption grey--text"
  }, [_vm._v(_vm._s(_vm.readyForLoad ? 'Loaded' : 'Valid'))])], 1) : _vm._e(), _vm._v(" "), (_vm.totRecs) ? _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "color": "error",
      "value": (_vm.totInvalid / _vm.totRecs * 100),
      "size": 50,
      "width": 7
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.readyForLoad ? _vm.totFail : _vm.totInvalid) + "\n                      ")]), _vm._v(" "), _c('br'), _c('div', {
    staticClass: "caption grey--text"
  }, [_vm._v(_vm._s(_vm.readyForLoad ? 'Failed' : 'Invalid'))])], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "small": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.lAction = 'upload'
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.totValid > 0) ? _c('v-btn', {
    staticClass: "accent",
    attrs: {
      "small": "",
      "disabled": _vm.beingSaved
    },
    nativeOn: {
      "click": function($event) {
        return _vm.uploadPPMPlanner($event)
      }
    }
  }, [_vm._v("Process the valid records")]) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    staticClass: "mt-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-data-table', {
    staticClass: "elevation-3 text-xs-left",
    attrs: {
      "headers": _vm.loadPPMHeadSm,
      "items": _vm.recsLoaded,
      "hide-actions": "",
      "disable-initial-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          class: (props.item.error ? (props.item.load_status === 'Failed' ? 'error' : 'error--text') : (props.item.load_status === 'Loaded' ? 'success' : '')),
          on: {
            "click": function($event) {
              props.item.error ? _vm.showError(props.item.error) : ''
            }
          }
        }, [_c('td', [_vm._v(_vm._s(props.item.ppm_cat))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.noneq_nm))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.asset_id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.ppm_title))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.freq))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.starting_month))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.sched_dt))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.noofyears))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.key_staff_id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.activity_by))])])]
      }
    }], null, false, 1056293527)
  })], 1)], 1)], 1), _vm._v(" "), (false) ? _c('v-card-actions', {
    staticClass: "pt-0"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cancelChanges($event)
      }
    }
  }, [_vm._v("Cancel")])], 1) : _vm._e()], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-bottom-sheet', {
    staticClass: "caption",
    attrs: {
      "inset": "",
      "max-width": "500px"
    },
    model: {
      value: (_vm.showSerHistFilter),
      callback: function($$v) {
        _vm.showSerHistFilter = $$v
      },
      expression: "showSerHistFilter"
    }
  }, [_c('v-card', [_c('v-card-text', [_c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Asset Name",
      "hide-details": "",
      "maxlength": "100"
    },
    model: {
      value: (_vm.filterHistList.asset_name),
      callback: function($$v) {
        _vm.$set(_vm.filterHistList, "asset_name", $$v)
      },
      expression: "filterHistList.asset_name"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Asset Tag",
      "hide-details": "",
      "maxlength": "30"
    },
    model: {
      value: (_vm.filterHistList.asset_tag),
      callback: function($$v) {
        _vm.$set(_vm.filterHistList, "asset_tag", $$v)
      },
      expression: "filterHistList.asset_tag"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Category",
      "items": _vm.catList,
      "item-value": "asset_cat_id",
      "item-text": "asset_cat",
      "hide-details": "",
      "multiple": "",
      "small": "",
      "chips": "",
      "clearable": "",
      "deletable-chips": "",
      "dense": ""
    },
    model: {
      value: (_vm.filterHistList.asset_cat_list),
      callback: function($$v) {
        _vm.$set(_vm.filterHistList, "asset_cat_list", $$v)
      },
      expression: "filterHistList.asset_cat_list"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Vendor filter",
      "items": _vm.vendors,
      "item-value": "vendor_id",
      "item-text": "vendor_name",
      "clearable": "",
      "chips": "",
      "multiple": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.filterHistList.vendor_list),
      callback: function($$v) {
        _vm.$set(_vm.filterHistList, "vendor_list", $$v)
      },
      expression: "filterHistList.vendor_list"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showSerHistFilter = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": _vm.clearHistFilter
    }
  }, [_vm._v("Clear all")]), _vm._v(" "), _c('v-btn', {
    staticClass: "ma-0",
    attrs: {
      "flat": "",
      "color": "accent"
    },
    on: {
      "click": _vm.applyHistFilter
    }
  }, [_vm._v("Apply")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "600px"
    },
    model: {
      value: (_vm.showServiceHistDet),
      callback: function($$v) {
        _vm.showServiceHistDet = $$v
      },
      expression: "showServiceHistDet"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "py-0 subheading font-weight-bold grey lighten-4"
  }, [_vm._v("\n          Asset Details\n          "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showServiceHistDet = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-container', {
    staticClass: "pt-0 px-0",
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "primary lighten-1",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs5": ""
    }
  }, [_c('div', {
    staticClass: "caption white--text"
  }, [_vm._v("Asset Name: ")]), _vm._v(" "), _c('div', {
    staticClass: "font-weight-bold white--text"
  }, [_vm._v(_vm._s(_vm.serviceHistDet.asset_name))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('div', {
    staticClass: "caption white--text"
  }, [_vm._v("Asset Category: ")]), _vm._v(" "), _c('div', {
    staticClass: "font-weight-bold white--text"
  }, [_vm._v(_vm._s(_vm.serviceHistDet.asset_cat))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('div', {
    staticClass: "caption white--text"
  }, [_vm._v("Asset Tag: ")]), _vm._v(" "), _c('div', {
    staticClass: "font-weight-bold white--text"
  }, [_vm._v(_vm._s(_vm.serviceHistDet.asset_tag))])])], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "pt-1": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "pt-2": ""
    }
  }, [_c('div', {
    staticClass: "subtitle black--text font-weight-bold"
  }, [_vm._v("\n                  Service History Details\n                ")])])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "pt-1": ""
    }
  }, [_c('v-card-text', {
    staticClass: "ma-0 pa-0"
  }, [_c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.serviceHistListHead,
      "items": _vm.serviceHistBasedOnAsset,
      "hide-actions": "",
      "disable-initial-sort": "",
      "dense": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.handy.formatDate(props.item.service_hist_dt)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.service_hist_desc))]), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('td', [_vm._v(_vm._s(props.item.service_hist_cost ? _vm.handy.formatCur(props.item.service_hist_cost) : ''))]) : _vm._e()])]
      }
    }])
  })], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "color": _vm.sbarCol,
      "timeout": 2000,
      "multi-line": ""
    },
    model: {
      value: (_vm.sbar),
      callback: function($$v) {
        _vm.sbar = $$v
      },
      expression: "sbar"
    }
  }, [_c('span', {
    staticClass: "mx-auto"
  }, [_vm._v(_vm._s(_vm.sbarMsg))])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// C:/Users/vijay/L180/prototypes/uni-uswebapp/~/vue-loader/lib/template-compiler?{"id":"data-v-c7b10260","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!C:/Users/vijay/L180/prototypes/uni-uswebapp/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PpmPlanner.vue
// module id = 865
// module chunks = 1